// extracted by mini-css-extract-plugin
export default {"paginado":"paginado_paginado__pJlNn","number":"paginado_number__4-Dn7","btn":"paginado_btn__welaR","span8":"paginado_span8__dLQIz","paginadodiv":"paginado_paginadodiv__mPkJq"};